module.exports = __webpack_public_path__ + "img/style_model_preview_670.2939ff04.jpg";